import React, { Component } from 'react'
import { Icon } from 'antd'

import { NavLink } from 'react-router-dom'

export default class Detail extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { policies } = this.props
        return (
            <div style={{ cursor: 'pointer' }}>
                <div style={{ textDecoration: 'underline' }} onClick={() => this.toggleVisibility()}>
                    <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                    <span>לפירוט</span>
                </div>
                <div
                    style={{
                        display: `${this.state.open ? 'flex' : 'none'}`,
                        paddingRight: '1.5rem',
                        flexDirection: 'column'
                    }}
                >
                    {policies.map((policy, ind) => (
                        <NavLink
                            key={ind}
                            to={`/insurance/${policy.company_id}/${policy.policy_id || 1055}`}
                            target="_blank"
                        >
                            {policy.company_name} - {policy.sub_name} | ₪{policy.policy_id ? policy.policy_price : 0}
                        </NavLink>
                    ))}
                </div>
            </div>
        )
    }
}
